import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-part-configuration',
    imports: [
        RouterModule
    ],
    template: `
    <router-outlet />
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class PartConfigurationComponent {

}
